export default "__VITE_ASSET__DdZL_BfN__"